import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import MediaDetail from './MediaDetail';
import Loading from '../Loading';
import UserPrompt from '../UserPrompt';
import UserInfo from '../UserInfo/UserInfo';
import {
  onDownloadUncompressed,
  deleteWorkRecords,
} from '../../actions/api/apis';
import {
  postMessageForCansuke,
  convertCansukeFormat,
  convertUnixtTimeToDateTimeSecond,
} from '../../lib/tools';
import { CANSUKE_RESULT } from '../../lib/constants';
import closeButton from '../../images/common/close.svg';
import UpdateTagsDialog from '../TimeLine/UpdateTagsDialog';
import { Main, Title, CloseButtonImage } from './styles/MediaPageStyles';

const MediaPage = ({
  mediaDetailHeight,
  isLoading,
  loadingMessages,
  apiToken,
  openUserInfo,
  userInfo,
  innerRole,
  mediaInfo,
  mediaFullScreenMode,
  mediaMapFullScreenMode,
  operators,
  dispatch,
  history,
  isOpenMore,
  isOpenAnalysis,
  previous,
  openUpdateTagsDialog,
  provider,
  targetGroupId,
  userGroups,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const deletePromptMessage = formatMessage({
    id: 'userPrompt.message.dataDelete',
  });
  const deleteButtonOk = formatMessage({ id: 'userPrompt.button.delete' });
  const deleteButtonNg = formatMessage({ id: 'userPrompt.button.noDelete' });
  const deleteButtonArray = [
    { name: deleteButtonOk, type: 0 },
    { name: deleteButtonNg, type: 1 },
  ];
  const workRecordIds = [mediaInfo.id];
  const deleteOnAccept = ret => {
    const param = { disableType: '2', workRecordIds };
    if (ret === 0) {
      dispatch(deleteWorkRecords(apiToken, param));
      history.goBack();
    }
  };
  const checkbox = { ids: workRecordIds };
  return (
    <Main className="mainPage">
      {isLoading && <Loading loadingMessages={loadingMessages} />}
      {openUserInfo && (
        <UserInfo
          userInfo={userInfo}
          openUserInfo={openUserInfo}
          onClose={() => dispatch({ type: 'CLOSE_USER_INFO_DIALOG' })}
        />
      )}
      {openUpdateTagsDialog && <UpdateTagsDialog checkbox={checkbox} />}
      <UserPrompt />
      <Title id="title">
        <div>
          <FormattedMessage id="media.detail.title" />
        </div>
        <CloseButtonImage
          id="mediaCloseButton"
          role="presentation"
          src={closeButton}
          alt="closeButton"
          className="button"
          onClick={() => history.push(previous)}
        />
      </Title>
      <MediaDetail
        mediaDetailHeight={mediaDetailHeight}
        innerRole={innerRole}
        mediaInfo={mediaInfo}
        operators={operators}
        mediaFullScreenMode={mediaFullScreenMode}
        mediaMapFullScreenMode={mediaMapFullScreenMode}
        isOpenMore={isOpenMore}
        isOpenAnalysis={isOpenAnalysis}
        userGroups={userGroups}
        onChangePage={searchPosition =>
          dispatch({ type: 'UPDATE_SEARCH_POSITION', searchPosition })
        }
        onToggleAction={() => dispatch({ type: 'OPEN_AND_CLOSE_MORE' })}
        onDownloadUncompressed={() => {
          dispatch({ type: 'OPEN_AND_CLOSE_MORE' });
          dispatch(
            onDownloadUncompressed(apiToken, mediaInfo.id, targetGroupId),
          );
        }}
        onPost={() => {
          postMessageForCansuke(
            convertCansukeFormat(
              CANSUKE_RESULT.complete,
              mediaInfo.mediaFileUrl,
              convertUnixtTimeToDateTimeSecond(mediaInfo.recordedDate),
              mediaInfo.operatorName,
            ),
          );
        }}
        onUpdateTagsDialog={() => {
          dispatch({ type: 'OPEN_AND_CLOSE_MORE' });
          // 記録データに設定されているタグ情報をeditOptionsに連携
          dispatch({ type: 'UPDATE_FREE_TAG', freeTag: mediaInfo.freeTag });
          dispatch({ type: 'OPEN_UPDATE_TAGS_DIALOG' });
        }}
        onDelete={() => {
          dispatch({
            type: 'OPEN_USER_PROMPT',
            promptMessage: deletePromptMessage,
            buttonArray: deleteButtonArray,
            onAccept: deleteOnAccept,
          });
        }}
        onToggleResult={() => dispatch({ type: 'SWITCH_MEDIA_FULLSCREEN' })}
        onToggleMap={() => dispatch({ type: 'SWITCH_MEDIA_MAP' })}
        provider={provider}
      />
    </Main>
  );
};

MediaPage.propTypes = {
  mediaDetailHeight: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadingMessages: PropTypes.array.isRequired,
  apiToken: PropTypes.string.isRequired,
  openUserInfo: PropTypes.bool.isRequired,
  userInfo: PropTypes.object.isRequired,
  innerRole: PropTypes.number.isRequired,
  mediaInfo: PropTypes.object.isRequired,
  mediaFullScreenMode: PropTypes.number.isRequired,
  mediaMapFullScreenMode: PropTypes.number.isRequired,
  operators: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isOpenMore: PropTypes.bool.isRequired,
  isOpenAnalysis: PropTypes.bool.isRequired,
  previous: PropTypes.string.isRequired,
  openUpdateTagsDialog: PropTypes.bool.isRequired,
  provider: PropTypes.object.isRequired,
  targetGroupId: PropTypes.string.isRequired,
  userGroups: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  isLoading: state.main.isLoading,
  loadingMessages: state.main.loadingMessages,
  apiToken: state.main.apiToken,
  openUserInfo: state.main.openUserInfo,
  userInfo: state.main.userInfo,
  innerRole: state.main.innerRole,
  menuIsOpen: state.main.menuIsOpen,
  mediaInfo: state.media.info,
  mediaFullScreenMode: state.media.mediaFullScreenMode,
  mediaMapFullScreenMode: state.media.mediaMapFullScreenMode,
  operators: state.operator.operators,
  isMobile: state.main.isMobile,
  isOpenMore: state.media.isOpenMore,
  isOpenAnalysis: state.media.isOpenAnalysis,
  previous: state.media.previous,
  openUpdateTagsDialog: state.timeline.openUpdateTagsDialog,
  provider: state.main.provider,
  targetGroupId: state.main.targetGroupId,
  userGroups: state.main.userGroups,
});

export default withRouter(connect(mapStateToProps)(MediaPage));
